import { Directive } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

@Directive()
export abstract class EaContratCapiFormBuilder extends PrFormAbstract {
  options: any = {};
  isAutomaticFlux: boolean;

  generate(entity: any, options?) {
    if (!entity.type) {
      entity.type = 'manual';
    }

    this.options = options;
    this.isAutomaticFlux = entity.subLabel?.includes('via EUODIA');

    let allocation: UntypedFormGroup[] = [];
    if (entity)
      _.forEach(entity.repartition?.series, (support, i) =>
        allocation.push(
          this.formBuilder.group(
            this.createModel(
              {
                id: support.id,
                prSupportId: support.prSupportId,
                isin: support.isin,
                index: i,
                name: support.label,
                allocationPercentage: support.percentage,
                favorite: '',
                type: '',
                supportDescription: '',
                investedAmount: support.value,
                totalInvestedAmount: entity?.lastValue,
              },
              i,
            ),
          ),
        ),
      );

    let group = this.formBuilder.group({
      accountId: [entity?.accountId || null, Validators.required],
      userId: [entity?.userId || null, Validators.required],
      id: [entity?.id || null],
      subscriptionId: [entity?.subscriptionId || null],
      subscriptionSource: [
        entity?.subscriptionSource || 'BANK',
        Validators.required,
      ],
      investmentType: ['ASSETS', Validators.required],
      owners: [this.buildInitialOwners(entity), Validators.required],
      product: [entity?.label || null, Validators.required],
      // subLabel: [entity?.subLabel || null, Validators.required],
      startDate: [entity?.startDate || null, Validators.required],
      lastValue: [entity?.lastValue || null, Validators.required],
      purchasePrice: [entity?.purchasePrice || null, Validators.required],
      monthlyPayment: [entity?.monthlyPayment || null, Validators.required],
      nanti: [entity?.nanti || false, Validators.nullValidator],
      type: [entity?.type || null, Validators.required],
      allocation: this.formBuilder.array(allocation, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }

  public createModel(item, i?) {
    let model = {
      id: item ? item.id : null,
      isin: item ? item.isin || item.supportIsin : null,
      index: item && item.index ? item.index : !_.isNil(i) ? i : null,
      omniprodId: item ? item.omniProductId || item.omniprodId : null,
      name: item ? item.name : null,
      allocationPercentage: item ? item.allocationPercentage : null,
      totalInvestedAmount: item ? item.totalInvestedAmount : null,
      investedAmount: item ? item.investedAmount : null,
      prSupportId: item ? item.prSupportId : null,
    };
    return model;
  }

  extract() {
    let assetSupportList;
    if (!this.isAutomaticFlux)
      assetSupportList = _(this.form.value.allocation)
        .map(support => {
          return {
            ...support,
            label: support.name,
            isinCode: support.isin,
            percentage: support.allocationPercentage,
            initialAmount:
              this.form.value.lastValue * support.allocationPercentage,
            id: undefined,
            prSupportId: support.prSupportId ? support.prSupportId : undefined,
            startDate: new Date().getTime(),
            currentVolumeDate: new Date().getTime(),
          };
        })
        .value();

    let dto: any = {
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      subscriptionSource: this.emptyIsNull(this.form.value.subscriptionSource),
      id: this.emptyIsNull(this.form.value.id),
      investmentType: this.emptyIsNull(this.form.value.investmentType),
      owners: this.form.value.owners,
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      monthlyPayment: this.emptyIsNull(this.form.value.monthlyPayment),
      nanti: this.emptyIsNull(this.form.value.nanti),
      label: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.name)
        : undefined,
      productId: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.id)
        : undefined,
      subLabel: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.managerName)
        : undefined,
      managerProviderId: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.managerId)
        : undefined,
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      type: 'CONTRAT_CAPI',
      status: 'STARTED',
      current: true,
      assetSupportList: assetSupportList,
    };
    return dto;
  }
}
